export interface Theme {
  logo: string;
  client: string;
  border: string;
  bg: string;
  'bg-default': string;
  'home-subheading': string;
  'home-heading-text': string;
  'home-button-text': string;
  'gradient-home-button-text': string;
  'home-button-border': string;
  'button-bg': string;
  'action-button-bg': string;
  'text-600': string;
  'text-default-800': string;
  color: string;
  'star-stopColor': string;
  'star-stopOffsetColor': string;
  p_color: string;
  text_sub_heading?: string;
  s_color: string;
  gradient: string;
  sandraMessage: string;
  allowedPaths: string[];
  onlyPaymentsPathAllowed: boolean;
  hideSidebarPermanently: boolean;
  showSsnField: boolean;
  showDobField: boolean;
  showGarantorNumberField: boolean;
  showGarantorLastNameField: boolean;

}
export const THEMES: Record<string, Theme> = {
  default: {
    logo: 'PatientBud',
    client: "patientbud",
    text_sub_heading:
      'PatientBud simplifies healthcare billing—get clear, reliable answers in seconds.',
    color: 'teal',
    bg: '#0699A1',
    p_color: '#08B4BD',
    s_color: '#242E49',
    border: 'border-teal-300',
    'star-stopColor': '#42CBD2',
    'star-stopOffsetColor': '#0699A1',
    'bg-default': 'bg-[#F2F5F9]',
    'home-subheading': 'text-teal-40',
    'home-heading-text': 'text-gray-70',
    'button-bg': 'bg-teal-40',
    'home-button-border': 'border-teal-40',
    'home-button-text': 'text-teal-40',
    'gradient-home-button-text': 'from-amber-600 to-amber-400',
    'action-button-bg': 'bg-teal-50 hover:bg-teal-100',
    'text-600': 'text-teal-600',
    'text-default-800': 'text-gray-800',
    gradient: 'bg-teal-gradient',
    sandraMessage: "Hello! I'm Sandra, your AI assistant for medical billing and insurance queries. How can I help you today?",
    allowedPaths: ['/payments'],
    onlyPaymentsPathAllowed: false,
    hideSidebarPermanently: true,
    showSsnField: true,
    showDobField: true,
    showGarantorNumberField: true,
    showGarantorLastNameField: true,
  },
  ovum: {
    logo: 'Ovum',
    client: "ovum",
    text_sub_heading:
      'Hi, I am Sandra at Ovum! Ask me any insurance, offers, pricing, estimate or bill related question!',
    color: 'orange',
    bg: '#351C48',
    p_color: '#502C3B',
    s_color: '#5B4074',
    border: 'border-orange-300',
    'star-stopColor': '#8D5B6F',
    'star-stopOffsetColor': '#351C48',
    'bg-default': 'bg-[#F8F9FC]',
    'home-subheading': 'text-[#502C3B]',
    'button-bg': 'bg-orange',
    'home-button-text': 'text-orange',
    'home-button-border': 'border-orange',
    'home-heading-text': 'text-gray-900',
    'gradient-home-button-text': 'from-purple-600 to-blue-400',
    'action-button-bg': 'bg-orange',
    'text-600': 'text-[#502C3B]',
    'text-default-800': 'text-gray-800',
    gradient: 'bg-orange-gradient',
    sandraMessage: "Hello! I'm Sandra, your Ovum AI assistant. How can I help you today?",
    allowedPaths: ['/'],
    onlyPaymentsPathAllowed: false,
    hideSidebarPermanently: true,
    showSsnField: false,
    showDobField: false,
    showGarantorNumberField: false,
    showGarantorLastNameField: false,
  },
  abchospital: {
    logo: 'AbcHospital',
    client: "abchospital",
    text_sub_heading:
      'Abc Hospital simplifies healthcare billing—get clear, reliable answers in seconds.',
    color: 'teal',
    bg: '#0699A1',
    p_color: '#08B4BD',
    s_color: '#242E49',
    border: 'border-teal-300',
    'star-stopColor': '#42CBD2',
    'star-stopOffsetColor': '#0699A1',
    'bg-default': 'bg-[#F2F5F9]',
    'home-subheading': 'text-teal-40',
    'home-heading-text': 'text-gray-70',
    'button-bg': 'bg-teal-40',
    'home-button-border': 'border-teal-40',
    'home-button-text': 'text-teal-40',
    'gradient-home-button-text': 'from-purple-600 to-blue-400',
    'action-button-bg': 'bg-teal-50 hover:bg-teal-100',
    'text-600': 'text-teal-600',
    'text-default-800': 'text-gray-800',
    gradient: 'bg-teal-gradient',
    sandraMessage: "Hello! I'm Sandra, your AI assistant for medical billing and insurance queries. How can I help you today?",
    allowedPaths: ['/payments'],
    onlyPaymentsPathAllowed: false,
    hideSidebarPermanently: false,
    showSsnField: false,
    showDobField: false,
    showGarantorNumberField: false,
    showGarantorLastNameField: false,
  },
  stluke: {
    logo: 'StLuke',
    client: "stluke",
    text_sub_heading: '',
    // St. Luke palette (from logo SVG): primary maroon + soft warm neutrals
    color: 'maroon',
    bg: '#F2F5F9',
    p_color: '#71001F',
    s_color: '#242E49',
    border: 'border-[#71001F]',
    'star-stopColor': '#71001F',
    'star-stopOffsetColor': '#9B1236',
    'bg-default': 'bg-[#F2F5F9]',
    'home-subheading': 'text-[#242E49]',
    'home-heading-text': 'text-[#242E49]',
    'button-bg': 'bg-[#71001F]',
    'home-button-border': 'border-[#71001F]',
    'home-button-text': 'text-[#71001F]',
    'gradient-home-button-text': 'from-[#71001F] to-[#9B1236]',
    'action-button-bg': 'bg-[#F4F5D7] hover:bg-[#EEEFCB]',
    'text-600': 'text-[#71001F]',
    'text-default-800': 'text-[#242E49]',
    gradient: 'bg-gradient-to-r from-[#71001F] to-[#9B1236]',
    sandraMessage: "Hello! I'm Sandra, your AI assistant for medical billing and insurance queries. How can I help you today?",
    allowedPaths: ['/payments'],
    onlyPaymentsPathAllowed: true,
    hideSidebarPermanently: true,
    showSsnField: true,
    showDobField: true,
    showGarantorNumberField: true,
    showGarantorLastNameField: true,
  },
  axis: {
    logo: 'Axis',
    client: "axis",
    text_sub_heading:
      '',
    color: 'teal',
    bg: '#0699A1',
    p_color: '#08B4BD',
    s_color: '#242E49',
    border: 'border-teal-300',
    'star-stopColor': '#42CBD2',
    'star-stopOffsetColor': '#0699A1',
    'bg-default': 'bg-[#F2F5F9]',
    'home-subheading': 'text-teal-40',
    'home-heading-text': 'text-gray-70',
    'button-bg': 'bg-teal-40',
    'home-button-border': 'border-teal-40',
    'home-button-text': 'text-teal-40',
    'gradient-home-button-text': 'from-amber-600 to-amber-400',
    'action-button-bg': 'bg-teal-50 hover:bg-teal-100',
    'text-600': 'text-teal-600',
    'text-default-800': 'text-gray-800',
    gradient: 'bg-teal-gradient',
    sandraMessage: "Hello! I'm Sandra, your AI assistant for medical billing and insurance queries. How can I help you today?",
    allowedPaths: ['/payments'],
    onlyPaymentsPathAllowed: false,
    hideSidebarPermanently: true,
    showSsnField: true,
    showDobField: true,
    showGarantorNumberField: true,
    showGarantorLastNameField: true,
  }
};
